import classnames from 'classnames';

import EmptyImg from '../../assets/images/70eef70c-84d4-47f0-b871-0ccdc6b78977.webp';
import { BaseComponentProps } from '../../types/base-component.types';

import styles from './Empty.module.scss';

type ContainerProps = BaseComponentProps & {
  title?: string;
};

function Empty({ className, title }: ContainerProps) {
  return (
    <div
      className={classnames(styles['main'], className)}
      data-test-id="ui-empty"
    >
      <div className={styles['wrapper']}>
        <img className={styles['image']} src={EmptyImg} />
        <h1 className={styles['title']}>{title ?? '¡Ups! No hay nada aquí'}</h1>
      </div>
    </div>
  );
}

export { Empty };
